import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,Select   } from 'antd';

import {PlusCircleOutlined,MinusCircleOutlined } from '@ant-design/icons' ;

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import add from '../../assets/images/icon/add.png';
import edit from '../../assets/images/icon/edit.png';
import boy from '../../assets/images/icon/boy.png';
import girl from '../../assets/images/icon/girl.png';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			tab: '1',
			school_list: [],
			values: [1],
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
		
	}
	
	handletabchange=(e)=>{
			this.setState({
					tab: e,
				});
			
	}
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
	
  };
  
  createUI(){
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     
	const lenght = this.state.values.length;
     return this.state.values.map((el, i) => 
		
         <div class={`col m12 no-padd ${i}`} key={i}>
										
										<div class="col m12 s12 ">
											<div class="col m4 s4 mb-10">
												<input type="text" name="first_name" id={`period_time_${i}`}  required/>
											</div>
											<div class="col m4 s4 mb-10">
												<input type="text" name="first_name" required/>
											</div>
											<div class="col m2 s4 mb-10">
												<input type="text" name="first_name" required/>
											</div>
											<div class="col m2 s4 mb-10">
												<span class="time"  onClick={this.addRow.bind(this)}><PlusCircleOutlined /></span>
												
												<span  class="time" onClick={this.removeClick.bind(this, i)}><MinusCircleOutlined /></span>
											</div>
										</div>
						 
											
						  
					
									
         </div>          
     )
  }
  
  addClick(){
    this.setState(prevState => ({ values: [...prevState.values, '']}))
  }
  
  removeClick(i){
     let values = [...this.state.values];
     values.splice(i,1);
     this.setState({ values });
  }
  
  addRow() {
  alert('hii');
  const div = document.createElement('div');
  const number = '0'	
  div.className = 'row';
  div.innerHTML = `
					<div class="col m12 s12 ">
							<div class="col m4 s4 mb-10">
								<input type="text" name="first_name" id="id_`+ number +`" required/>
							</div>
							<div class="col m4 s4 mb-10">
								<input type="text" name="first_name" required/>
							</div>
							<div class="col m2 s4 mb-10">
								<input type="text" name="first_name" required/>
							</div>
							<div class="col m2 s4 mb-10">
								<p class="time"  onClick={this.addRow}>Add</p>
												
								<span  class="time" onClick={this.removeClick.bind(this, i)}><MinusCircleOutlined /></span>
							</div>
					</div>
  `;

  document.getElementById('content').appendChild(div);
}

	render()

	{
	
	const { size } = this.state;
	
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
			
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m6 l6 pt-10">
                        <h5 class="breadcrumbs-title"><span>Check Who Is Free</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                      <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/time-table">Time Table</a>
                           </li>
                           <li class="breadcrumb-item active">Check Who Is Free
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		 	
           
		   <div class="col s12 m12 ex-padd view-Profile "> 
		
		   
            <div class="container">
			   <div class="col s12 m12 mb-20  mh-500 ">
                  <section class="section food">
					<div class="children mb-20 mh-40">
                    
						<div class="row">
								<div class="col m2 s12 mb-20">
									<label>Select Academic Year</label>
									<Select onChange={this.change_label}>
										 <Select.Option value="2022-2023">2022-2023</Select.Option>	
										 <Select.Option value="2021-2022">2021-2022</Select.Option>	
										 <Select.Option value="2020-2021">2020-2021</Select.Option>
										 <Select.Option value="2019-2020">2019-2020</Select.Option>
										 <Select.Option value="2018-2019">2018-2019</Select.Option>
									</Select>
								</div>
								<div class="col m2 s12 mb-20">
									<label>Select Day</label>
									<Select onChange={this.change_label}>
										<Select.Option value="Monday">Monday</Select.Option>
										<Select.Option value="Tuesday">Tuesday</Select.Option>
										<Select.Option value="Wednesday">Wednesday</Select.Option>
										<Select.Option value="Thursday">Thursday</Select.Option>
										<Select.Option value="Friday">Friday</Select.Option>
										<Select.Option value="Saturday">Saturday</Select.Option>
									</Select>
								</div>
								<div class="col m2 s12 mb-20">
									<label>Start Time </label>
									<TimePicker use12Hours format="h:mm a" onChange={onChange} />
								</div>
								<div class="col m2 s12 mb-20">
									<label>End Time </label>
									<TimePicker use12Hours format="h:mm a" onChange={onChange} />
								</div>
								<div class="col m2 s12 mb-20 mt-20">
									<Button className="snd-btn" >Show</Button>
								</div>
						</div>
						
						
						<div class="col m12 s12">
							
							<table  class="cust_table">
								<thead>
									<tr>
										<th>No</th>
										<th>Teacher Name</th>
										<th>Type</th>
										<th>Max Lecture Limit</th>
										<th>Assign Lecture</th>
										<th>Substitute Lecture</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>1</td>
										<td>TARIQUE ANSARI</td>
										<td>Teaching</td>
										<td>42</td>
										<td>-</td>
										<td>0</td>
									</tr>
									<tr>
										<td>1</td>
										<td>TARIQUE ANSARI</td>
										<td>Teaching</td>
										<td>42</td>
										<td>-</td>
										<td>0</td>
									</tr>
								</tbody>
							</table>
							
							
							
							
						</div>
						
						
					</div> 
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
